import React from "react"
import { ListaAditivosProps } from "./types"
import { Aditivo } from "../Aditivo"
import { DommusAlertaAmarelo } from "../../../../../../../components/DommusAlertaAmarelo"

export function ListaAditivos({ aditivos }: ListaAditivosProps) {
    return aditivos.length ? 
      <>
        {aditivos.map((aditivo, idx) => (
          <Aditivo 
            key={`aditivo=${aditivo.id}`} 
            aditivo={aditivo} 
            idx={idx}
          />
        ))}
      </> : 
      <DommusAlertaAmarelo mensagem="Nenhum aditivo cadastrado." classe="mb-0"/>
  }